export const filterDuplicateCancelledPaxsByGreatestRevisions = ({
  duplicatePassengersProducts = [],
  createdRevision,
  cancelled,
  cancelledRevision
}) => {
  const isEveryDuplicatePassengerProductsCancelled = duplicatePassengersProducts.every(({ cancelled }) => cancelled);

  if (isEveryDuplicatePassengerProductsCancelled) {
    const allDuplicatePassengerProductsCancelledRevisions = duplicatePassengersProducts.flatMap(
      ({ cancelledRevision }) => cancelledRevision ?? 0
    );
    const maxCancelledRevisionOfDuplicatePassengerProducts = Math.max(...allDuplicatePassengerProductsCancelledRevisions, 0);

    return cancelledRevision >= maxCancelledRevisionOfDuplicatePassengerProducts;
  }

  return !cancelled && createdRevision >= cancelledRevision;
};
